export const RARITY_LABEL = { common: "Comum", rare: "Rara", epic: "Épica", mythic: "Mítica" };
export const RARITY_CLASS = { common: "rarity-common", rare: "rarity-rare", epic: "rarity-epic", mythic: "rarity-mythic" };
